import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DiscountBadge from './discountBadge';

interface ItemPercentProps extends WithTranslation {
    value: number;
}

const ItemPercent = (
    {
        value,
        t,
    }: ItemPercentProps
) => (<DiscountBadge>
    {t('customers.customer.discounts.discount')}:{value}%</DiscountBadge>);

export default withTranslation()(ItemPercent);
